import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=3730f9d4&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=3730f9d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3730f9d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockUserDialog: require('/var/jenkins_home/workspace/prod-web-xfans/components/block/BlockUserDialog.vue').default})
